import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { setUiChangeStoreConfirmModal } from 'app/store/reducers/ui.reducer';
import { setCustomerStore } from 'app/store/reducers/customer.reducer';
import { getStoreModelById } from 'app/store/reducers/store.reducer';
import { IStoreModel } from 'entities/Store/Store.models';

export const useChangeStore = () => {
  const dispatch = useAppDispatch();

  const { cartModel, customerModel, storeModel } = useAppSelector((state) => ({
    cartModel: state.cart.cartModel,
    customerModel: state.customer.customerModel,
    storeModel: state.store.storeModel,
  }));

  const changeStore = useCallback(
    (newStore: IStoreModel) => {
      const { id: newStoreId } = newStore;
      const { store: customerStore, userId } = customerModel || {};
      const finalStore = customerStore || storeModel;
      const isSameStore = finalStore && finalStore.id === newStoreId;

      if (isSameStore) {
        return;
      }

      if (userId) {
        dispatch(setCustomerStore({ id: userId, store: newStoreId }));
        return;
      }

      dispatch(getStoreModelById(newStoreId));
    },
    [customerModel, storeModel, dispatch],
  );

  const handleSelectStore = useCallback(
    (selectedStore: IStoreModel) => {
      const isCartEmpty = !cartModel || (cartModel?.items?.length ?? 0) === 0;

      if (!isCartEmpty) {
        dispatch(setUiChangeStoreConfirmModal({ isVisible: true, selectedStore }));
        return;
      }

      changeStore(selectedStore);
    },
    [cartModel, changeStore, dispatch],
  );

  const handleChangeStoreConfirm = useCallback(
    (store: IStoreModel) => {
      changeStore(store);
    },
    [changeStore],
  );

  return { handleSelectStore, handleChangeStoreConfirm };
};
